import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import {
  Transition,
  Container,
  Header,
  Segment,
  Button
} from "semantic-ui-react";
import TablaColegios from "./listadoColegios/TablaColegios";
import { colegiosOps } from "../../ducks/colegios";
import _ from "lodash";

class ListadoColegios extends React.Component {
  state = {
    redirect: false
  };

  componentDidMount() {
    this.props.obtenerListaColegios();
  }

  componentWillUnmount() {
    this.props.resetListaColegios();
  }

  handleRowClick = id => {
    this.props.obtenerDetalleColegio(id);
    this.setState({
      redirect: true,
      redirectItem: <Redirect push to={`/detalle/colegio/${id}`} />
    });
  };

  handleVolver = () => this.props.history.goBack();

  render() {
    if (this.state.redirect) {
      return this.state.redirectItem;
    }

    return (
      <Transition.Group animation="scale" duration={250}>
        {!_.isEmpty(this.props.listaColegios) && (
          <Container textAlign="center">
            <Segment basic>
              <Button
                content="Cerrar"
                floated="right"
                color="pink"
                icon="cancel"
                onClick={this.handleVolver}
              />

              <Header inverted as="h2">
                Listado de Colegios
              </Header>
            </Segment>
            <Segment loading={_.isEmpty(this.props.listaColegios)}>
              <TablaColegios
                listaColegios={this.props.listaColegios}
                handleRowClick={this.handleRowClick}
              />
            </Segment>
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({
  listaColegios: state.colegios.listaColegios
});

const actions = {
  obtenerListaColegios: colegiosOps.obtenerListaColegios,
  obtenerDetalleColegio: colegiosOps.obtenerDetalleColegio,
  resetListaColegios: colegiosOps.resetListaColegios
};

export default connect(mapStateToProps, actions)(ListadoColegios);



// WEBPACK FOOTER //
// ./src/pages/listados/ListadoColegios.jsx